export default __webpack_public_path__ + "static/media/oi_2.a3df3867.mp3";